import { LOCAL_STORAGE_TOKEN } from "../constans/roles";

export default async function fetchGet ( url , options = {
    reqToken: true
}) {

    let headers = {}

    try {

    if(options.reqToken)
        headers["x-auth-token"] = localStorage.getItem(LOCAL_STORAGE_TOKEN)

    const json = await fetch(url, {
        headers
      });

      const data = await json.json();

      console.log(data)
      return  data
    }   catch(err) {
        console.error(err)
    }
    
   
}